import { capitalize } from 'lodash'

import {
  PAYMENT_DEMONSTRATIVE_COPAN_DATA,
  GET_PAYMENT_DEMONSTRATIVE_COPAN_ERROR,
  PAYMENT_DEMONSTRATIVE_COPAN_LOADING,
  GET_REPORTS_BEING_GENERATED_COPAN,
  REMOVE_PAYMENT_DEMONSTRATIVE_COPAN,
  PAYMENT_DEMONSTRATIVE_NO_DATA_COPAN,
} from 'store/constants'

export const initialState = {
  status: {},
  docs: [],
  loadingPaymentDemonstrativeCopan: false,
  errorPaymentDemonstrativeCopan: false,
  reportsBeingGeneratedCopan: [],
  datesWithNoDataCopan: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_DEMONSTRATIVE_COPAN_DATA:
      const pwbusPayloadId = action.payload.applications.paymentDemonstrative.reportsPerDay.pwbus_correlation_id
      const existingItemIndex = state.docs.findIndex(
        (item) => item.applications.paymentDemonstrative.reportsPerDay.pwbus_correlation_id === pwbusPayloadId
      )

      if (existingItemIndex >= 0) {
        let docs = state.docs
        docs[existingItemIndex] = action.payload

        return { ...state, docs }
      } else {
        return { ...state, docs: [...state.docs, action.payload] }
      }

    case REMOVE_PAYMENT_DEMONSTRATIVE_COPAN:
      const index = action.payload
      let docs = state.docs
      docs.splice(index, 1)
      const newState = { ...state, docs }
      return newState

    case GET_PAYMENT_DEMONSTRATIVE_COPAN_ERROR:
      return { ...state, errorPaymentDemonstrativeCopan: action.payload }

    case PAYMENT_DEMONSTRATIVE_COPAN_LOADING:
      return { ...state, loadingPaymentDemonstrativeCopan: action.payload }

    case GET_REPORTS_BEING_GENERATED_COPAN:
      const reportsBeingGeneratedCopan = JSON.parse(localStorage.getItem('reportsBeingGeneratedCopan'))

      return { ...state, ...reportsBeingGeneratedCopan }
    case PAYMENT_DEMONSTRATIVE_NO_DATA_COPAN:
      return { ...state, datesWithNoDataCopan: [...state.datesWithNoDataCopan, action.payload] }
    default:
      return state
  }
}
